import { create } from "zustand";
import { dietPlanApi } from "../api_layer/api";

export const useDiet = create((set) => ({
  dietData:[],
  dietLoading: false,
  fetchDietData: async (caseId) => {
    try {
      set({ dietLoading: true, error: null });
      const response = await dietPlanApi(caseId);
      set({ dietData: response.data, dietLoading: false });
    } catch (error) {
      set({ error: error.message, dietLoading: false });
    }
  },
}));

